import api from "./api.js";

export default class CommunityApi {
  //커뮤니티 카테고리
  static async getCategoryList(data) {
    return await api.get(`api/community-category`, data);
  }

  //커뮤니티 카테고리
  static async getList(data) {
    return await api.get(`api/community-post`, data);
  }

  static async getDetail(id, data) {
    return await api.get(`api/community-post/${id}`, data);
  }

  static async delCommunity(data) {
    return await api.del(`api/community-post`, data);
  }

  static async register(data) {
    return await api.post(`api/community-post`, data);
  }

  static async edit(id, data) {
    return await api.patch(`api/community-post/${id}`, data);
  }

  //커뮤니티 신고
  static async report(data) {
    return await api.post(`api/community-report`, data);
  }

  // 댓글
  static async commentList(data) {
    return await api.get(`api/community-comment`, data);
  }

  static async registerComment(data) {
    return await api.post(`api/community-comment`, data);
  }

  static async editComment(id, data) {
    return await api.patch(`api/community-comment/${id}`, data);
  }

  static async delComment(data) {
    return await api.del(`api/community-comment`, data);
  }
}
